import {GemSettings, GemSettingsFeature, NonNullableFeaturesSettingsConfig} from 'app/utils/config/interface';

export function getGemSettingsFeature<T extends NonNullableFeaturesSettingsConfig>(gemSettings: GemSettings, featureName: GemSettingsFeature) {
    return gemSettings.features.find((feature) => feature?.featureName === featureName) as T | undefined;
}
